const PERMISSION_KEY= "core:authz_subject_permission";
const PAGE_URL = {
    AUTHZ_SUBJECT_PERMISSION_PAGE: "/admin/core/authz-subject-permission"
}

export {PERMISSION_KEY, PAGE_URL}

